import { useState, lazy, Suspense } from "react";
import Header from "@/components/fedari/Header";
import Footer from "@/components/fedari/Footer";
import Breadcrumbs from "@/components/layout/Breadcrumbs";

const QuoteDialog = lazy(() => import("@/components/booking/QuoteDialog"));

/**
 * Shared shell for all SEO content pages: header, breadcrumbs, semantic
 * <main>, footer and the quote dialog wired up. (Legacy booking retired.)
 */
export default function PageShell({ breadcrumbs, children, quoteContext = null }) {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteLoaded, setQuoteLoaded] = useState(false);

  const onQuote = () => { setQuoteLoaded(true); setQuoteOpen(true); };
  const onBook = onQuote; // legacy booking retired — all CTAs open the quote journey

  return (
    <div className="bg-white pb-16 lg:pb-0">
      <Header onBook={onBook} onQuote={onQuote} />
      {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
      <main id="main-content">{typeof children === "function" ? children({ onBook, onQuote }) : children}</main>
      <Footer onBook={onBook} onQuote={onQuote} />
      {quoteLoaded && <Suspense fallback={null}><QuoteDialog open={quoteOpen} onClose={() => setQuoteOpen(false)} context={quoteContext} /></Suspense>}
    </div>
  );
}
